import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'blur-warning-dialog',
  standalone: false,
  templateUrl: './blur-warning-dialog.component.html',
  styleUrl: './blur-warning-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlurWarningDialogComponent {
  public dialogRef = inject(MatDialogRef<BlurWarningDialogComponent>);

  closeAndCancel(): void {
    this.dialogRef.close({ result: 'cancel' });
  }

  closeAndProceed(): void {
    this.dialogRef.close({ result: 'proceed' });
  }
}
